'use client';

import { Media, Setting } from '@/payload-types';
import { X } from 'lucide-react';
import { useState } from 'react';

import { CMSLink } from '@/components/Link';
import { MediaComponent } from '@/components/Media';
import FloatingContactIcon from '@/icons/FloatingContactIcon';
import { cn } from '@/utilities/cn';
import { WithSetting } from '@/types/WithSetting';

const FloatingContact = (props: WithSetting) => {
  const { setting } = props;
  const { contacts } = setting?.floatingContact || {};
  const [showContacts, setShowContacts] = useState<boolean>(false);

  const toggle = () => setShowContacts(!showContacts);

  return (
    <div className="flex flex-col gap-2">
      <div
        className={cn(
          'py-0 px-4 bg-white shadow-xl rounded-xl transition-all duration-500 origin-bottom grid grid-rows-0fr pointer-events-none max-w-0',
          showContacts && 'grid-rows-1fr pointer-events-auto py-4 max-w-screen',
        )}
      >
        <ul className="flex flex-col gap-2 overflow-hidden">
          {contacts?.map((contact, index) => (
            <li
              key={index}
              className="bg-neutral-100 px-3 py-2 rounded-xl flex justify-center items-center gap-2.5 cursor-pointer"
            >
              <CMSLink
                {...contact.link}
                label=""
                className="flex justify-center items-center gap-2.5"
              >
                <div className="w-6 h-6">
                  <MediaComponent
                    resource={{ ...(contact?.icon as Media), width: 40, height: 40 }}
                    imgClassName="w-full h-full object-contain"
                    className="w-full h-full"
                  />
                </div>
                <div className="min-w-36 flex flex-col items-start">
                  <h5 className="text-xs font-normal text-neutral-1000">{contact?.title}</h5>
                  <p className="text-sm text-secondary-500 font-semibold">{contact.link.label}</p>
                </div>
              </CMSLink>
            </li>
          ))}
        </ul>
      </div>
      <button
        type="button"
        onClick={toggle}
        className={cn(
          'ml-auto w-12 h-12 bg-white block rounded-full border-solid shadow-xl cursor-pointer p-3 z-50 drop-shadow-2xl',
          'flex items-center justify-center box-border transition-all duration-500',
          !showContacts && 'bg-secondary text-secondary shadow-contact hover:brightness-80',
        )}
        aria-label="phone"
      >
        {showContacts ? <X /> : <FloatingContactIcon className="ringing" color="white" />}
      </button>
    </div>
  );
};

export default FloatingContact;
